// extracted by mini-css-extract-plugin
export var deliveryRow = "_my-a";
export var fixedHeight = "_my-4";
export var freightLogo = "_my-9";
export var fullWidth = "_my-3";
export var priceColumn = "_my-5";
export var radioSelected = "_my-7";
export var radioUnselected = "_my-6";
export var selectedOption = "_my-2";
export var selectedOptionContainer = "_my-1";
export var selection = "_my-0";
export var tallSkeletonText = "_my-8";